export const USER_LOGOUT = "USER_LOGOUT";

export const userLogout = () => {
  return {
    type: USER_LOGOUT,
  };
};
